import Vue from 'vue';
import { getBoIdMapping } from '../../helpers/boIdMapping';
import { InstanceType } from '../../enums/InstanceType';
import { CGReservationStatus } from '@/enums/CGReservationStatus';
import { ApartmentDTO } from '@/model/ApartmentDTO';
import { FakeSaleStatus } from '../../enums/FakeSaleStatus';
import { omit } from 'lodash-es';

export async function apartmentDetailData(context: Vue) {
	var catalogNumber = context.$route.params.apartmentCatalogNumber;
	var produktId = parseInt(context.$route.query.produktId); // used to show fake sold apartments
 
	var apartment: ApartmentDTO;

	try {
		apartment = await context.$apartmentService.fetchApartment(catalogNumber, !produktId);
	} catch (error) {
		if (error.response.status === 404) {
			redirectToHomepage(context);
		}
	}

	if (apartment.cgReservationStatus === CGReservationStatus.ShowApartment) {
		redirectToHomepage(context);
	}

	if (apartment.fakeSaleStatus === FakeSaleStatus.Sold && apartment.id !== produktId) {
		redirectToHomepage(context);
	}

	if (apartment.sold && !produktId) {
		redirectToHomepage(context);
	}

	// check if location is allowed in the preview (for showing preparation time version)
	if (context.$route.query.predbezne && context.$route.query.csh) {
		if (apartment.location.id.toString() !== context.$route.query.predbezne) {
			redirectToHomepage(context);
		}
		if (context.$store.publicatingTimeId >= context.$store.timeId) {	// if the time version to be previewed has already been published
			context.$router.replace({ query: omit(context.$route.query, ['csh', 'predbezne']) }); // omit preview parameters
		}
	}

	return {
		apartment,
		boIdMapping: getBoIdMapping(InstanceType.Apartment, apartment)
	}
};

function redirectToHomepage(context: Vue) {
	context.$router.push('/'); // redirect to homepage
	throw new Error();
}
